module.exports = __webpack_public_path__ + "img/air.a431703c.jpg";